import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import React from 'react';
import Dot from './Dot';
import useNumItems from './hooks/useNumItems';

var Dots = function Dots() {
  var _useNumItems = useNumItems(),
      _useNumItems2 = _slicedToArray(_useNumItems, 1),
      numItems = _useNumItems2[0];

  return /*#__PURE__*/React.createElement("ul", {
    className: "react-film__dots"
  }, new Array(numItems).fill().map(function (_, itemIndex) {
    return (
      /*#__PURE__*/

      /* eslint-disable-next-line react/no-array-index-key */
      React.createElement(Dot, {
        "aria-label": itemIndex + 1 + '',
        itemIndex: itemIndex,
        key: itemIndex
      })
    );
  }));
};

export default Dots;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Eb3RzLmpzIl0sIm5hbWVzIjpbIlJlYWN0IiwiRG90IiwidXNlTnVtSXRlbXMiLCJEb3RzIiwibnVtSXRlbXMiLCJBcnJheSIsImZpbGwiLCJtYXAiLCJfIiwiaXRlbUluZGV4Il0sIm1hcHBpbmdzIjoiOzs7QUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBRUEsT0FBT0MsR0FBUCxNQUFnQixPQUFoQjtBQUNBLE9BQU9DLFdBQVAsTUFBd0IscUJBQXhCOztBQUVBLElBQU1DLElBQUksR0FBRyxTQUFQQSxJQUFPLEdBQU07QUFDakIscUJBQW1CRCxXQUFXLEVBQTlCO0FBQUE7QUFBQSxNQUFPRSxRQUFQOztBQUVBLHNCQUNFO0FBQUksSUFBQSxTQUFTLEVBQUM7QUFBZCxLQUNHLElBQUlDLEtBQUosQ0FBVUQsUUFBVixFQUFvQkUsSUFBcEIsR0FBMkJDLEdBQTNCLENBQStCLFVBQUNDLENBQUQsRUFBSUMsU0FBSjtBQUFBO0FBQUE7O0FBQzlCO0FBQ0EsMEJBQUMsR0FBRDtBQUFLLHNCQUFZQSxTQUFTLEdBQUcsQ0FBWixHQUFnQixFQUFqQztBQUFxQyxRQUFBLFNBQVMsRUFBRUEsU0FBaEQ7QUFBMkQsUUFBQSxHQUFHLEVBQUVBO0FBQWhFO0FBRjhCO0FBQUEsR0FBL0IsQ0FESCxDQURGO0FBUUQsQ0FYRDs7QUFhQSxlQUFlTixJQUFmIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IERvdCBmcm9tICcuL0RvdCc7XG5pbXBvcnQgdXNlTnVtSXRlbXMgZnJvbSAnLi9ob29rcy91c2VOdW1JdGVtcyc7XG5cbmNvbnN0IERvdHMgPSAoKSA9PiB7XG4gIGNvbnN0IFtudW1JdGVtc10gPSB1c2VOdW1JdGVtcygpO1xuXG4gIHJldHVybiAoXG4gICAgPHVsIGNsYXNzTmFtZT1cInJlYWN0LWZpbG1fX2RvdHNcIj5cbiAgICAgIHtuZXcgQXJyYXkobnVtSXRlbXMpLmZpbGwoKS5tYXAoKF8sIGl0ZW1JbmRleCkgPT4gKFxuICAgICAgICAvKiBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgcmVhY3Qvbm8tYXJyYXktaW5kZXgta2V5ICovXG4gICAgICAgIDxEb3QgYXJpYS1sYWJlbD17aXRlbUluZGV4ICsgMSArICcnfSBpdGVtSW5kZXg9e2l0ZW1JbmRleH0ga2V5PXtpdGVtSW5kZXh9IC8+XG4gICAgICApKX1cbiAgICA8L3VsPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgRG90cztcbiJdfQ==